var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4994 16.4767V19.1864C21.5036 20.2223 20.5722 21.0873 19.5264 20.9929C10.5 21 3.5 13.935 3.50706 4.96919C3.41287 3.92895 4.27358 3.00106 5.30811 3.00009H8.02325C8.46247 2.99577 8.88828 3.151 9.22131 3.43684C10.1681 4.24949 10.7771 7.00777 10.5428 8.10428C10.3599 8.96036 9.4969 9.55929 8.91019 10.1448C10.1986 12.4062 12.0746 14.2785 14.3405 15.5644C14.9272 14.9788 15.5273 14.1176 16.3851 13.935C17.4855 13.7008 20.2615 14.3106 21.0709 15.264C21.3579 15.6021 21.5104 16.0337 21.4994 16.4767Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.643716b62f20daa42a6b9083b2e70695.svg";
export { ForwardRef as ReactComponent };